import { type ReactNode } from 'react';

import { Heart2, Swirl, Lightning } from '@hungryroot/icons';
import { Heading, Paragraph } from '@hungryroot/ramen';

import styles from './HealthMetrics.module.css';

type HealthMetric = {
  metricName: string;
  title: string;
  metricValue: string;
  text: string;
  footnote?: number;
  Icon: (props: { className?: string }) => ReactNode;
};

const metrics: HealthMetric[] = [
  {
    title: 'Better health',
    metricValue: '90%',
    text: 'of customers have improved their health with Hungryroot.',
    footnote: 1,
    metricName: 'better-health',
    Icon: Heart2,
  },
  {
    title: 'More energy',
    metricValue: '93%',
    text: 'of customers feel more energized with Hungryroot.',
    footnote: 2,
    metricName: 'more-energy',
    Icon: Lightning,
  },
  {
    title: 'Less stress',
    metricValue: '96%',
    text: 'of customers feel less stressed with Hungryroot.',
    footnote: 2,
    metricName: 'less-stress',
    Icon: Swirl,
  },
];

export function HealthMetrics() {
  return (
    <section className={styles.container}>
      <Heading variant="HeroAlt" className={styles.heading}>
        <span>Eat healthier.</span> <span>Live better.</span>
      </Heading>

      <div className={styles.metrics}>
        {metrics.map(
          ({ metricName, title, text, metricValue, footnote, Icon }) => (
            <div
              className={`${styles['metric']} ${styles[metricName]}`}
              key={metricName}
            >
              <div className={styles['title-pill']}>
                <span className={styles['icon']}>
                  <Icon />
                </span>
                <Heading variant="H3">{title}</Heading>
              </div>
              <div className={styles['metric-value']}>{metricValue}</div>
              <Paragraph variant="lead" className={styles['text']}>
                {text} {footnote && <sup>{footnote}</sup>}
              </Paragraph>
            </div>
          )
        )}
      </div>
    </section>
  );
}
